<template>
    <page :showBackButton="true">
        <div
            v-if="day === '1' && isFragebogenPossible"
            class="u-m-bottom-xlarge"
        >
            <ion-card>
                Bevor es gleich losgeht, haben wir noch 2 Fragen an dich. Gleich
                beantworten und mit etwas Glück 1 von 5 exklusiven Buch-Packages
                von Univ.-Prof. Dr. Lalouschek gewinnen.
                <base-textarea
                    id="ziel"
                    v-model="ziel"
                    :label="zielLabel"
                    class="ion-margin-bottom"
                ></base-textarea>
                <base-textarea
                    id="augenmerk"
                    v-model="augenmerk"
                    :label="augenmerkLabel"
                    class="ion-margin-bottom"
                ></base-textarea>
                <base-input
                    type="email"
                    v-model="email"
                    label="E-Mail Adresse"
                    id="email-gewinnspiel"
                ></base-input>
                <base-checkbox
                    v-model="teilnahmebedingungen"
                    id="teilnahmebedingungen"
                    lines="none"
                    class="ion-margin-top"
                >
                    Ich bin mit den
                    <a href="#" @click="showFragebogenBedingungen"
                        >Teilnahmebedingungen</a
                    >
                    einverstanden.
                </base-checkbox>
                <ion-button
                    expand="block"
                    fill="clear"
                    color="primary"
                    @click="showFragebogenDatenschutz"
                >
                    Informationen zum Datenschutz
                </ion-button>
                <ion-button
                    expand="block"
                    :disabled="
                        ziel === '' ||
                        augenmerk === '' ||
                        teilnahmebedingungen === false ||
                        email === ''
                    "
                    @click="sendFragebogen"
                    >Jetzt mitspielen</ion-button
                >
            </ion-card>
        </div>
        <template v-if="Object.keys(my21Content).length !== 0">
            <ion-card class="c-my21-card" :class="'-' + my21Content.category">
                <ion-row>
                    <ion-col size="4" size-sm="3" size-md="2">
                        <img
                            class="c-my21-card__image"
                            :src="`${baseurl}/content/dam/klickmal/me1ns/my21/${my21Content.image}`"
                        />
                    </ion-col>
                    <ion-col class="c-my21-card__titlebox">
                        <div class="c-my21-card__day">Tag {{ day }}</div>
                        <div class="c-my21-card__title">
                            {{ my21Content.title }}
                        </div>
                    </ion-col>
                </ion-row>
            </ion-card>

            <ion-row>
                <ion-col v-html="my21Content.intro"></ion-col>
            </ion-row>

            <ion-row>
                <ion-col v-html="my21Content.subtitle"></ion-col>
            </ion-row>

            <ion-row>
                <ion-col>
                    <template
                        v-for="(value, key, index) in my21Content.content"
                    >
                        <div
                            class="c-accordion"
                            :class="{ '-open': accordionState[key] }"
                            :key="index"
                        >
                            <div
                                class="c-accordion__header"
                                @click="toggleAccordion(key)"
                            >
                                <div class="c-accordion__icon">
                                    <span :class="'icon-' + value.icon"></span>
                                </div>
                                <div
                                    class="c-accordion__headline"
                                    v-html="key"
                                ></div>
                                <div class="c-accordion__arrow">
                                    <ion-icon name="arrow-dropdown"></ion-icon>
                                </div>
                            </div>
                            <div class="c-accordion__body">
                                <div v-html="value.text"></div>
                                <div
                                    class="ion-margin-top"
                                    v-if="
                                        $store.state.isLoggedIn && value.dokbox
                                    "
                                >
                                    <b
                                        >Was hat dir heute besonders Spaß
                                        gemacht?</b
                                    ><br />
                                    Und welche Inhalte und Übungen möchtest du
                                    unbedingt festhalten? Deine Notizen findest
                                    du auch nach dem Programm jederzeit in
                                    deiner Dokbox.

                                    <base-textarea
                                        id="desc"
                                        v-model="formData.desc"
                                        :label="'Anmerkungen Tag ' + day"
                                        class="ion-margin-bottom"
                                    ></base-textarea>
                                    <div
                                        class="ion-padding-top ion-padding-bottom"
                                    >
                                        <b>
                                            Deine Uploadmöglichkeit für Tag
                                            {{ day }}
                                        </b>
                                    </div>
                                    <files-upload
                                        class="ion-margin-bottom"
                                        v-model="files"
                                        :existingFiles="existingFiles"
                                        :multiple="true"
                                        @delete-existing-file="
                                            deleteExistingFile
                                        "
                                        id="file"
                                        :shouldGetNativePhoto="true"
                                        :reset="resetFilesUpload"
                                    ></files-upload>
                                    <ion-button
                                        expand="block"
                                        class="ion-margin-top"
                                        @click="submitForm()"
                                        v-if="
                                            files.length === 0 &&
                                            existingFiles.length === 0 &&
                                            existingFilesToDelete.length !== 0
                                        "
                                        >Löschen</ion-button
                                    >
                                    <ion-button
                                        expand="block"
                                        class="ion-margin-top"
                                        @click="submitForm()"
                                        v-else-if="
                                            existingFiles.length !== 0 ||
                                            existingFilesToDelete.length !== 0
                                        "
                                        :disabled="
                                            files.length === 0 &&
                                            existingFilesToDelete.length ===
                                                0 &&
                                            existingDokboxDescription ===
                                                formData.desc
                                        "
                                        >Speichern</ion-button
                                    >
                                    <ion-button
                                        expand="block"
                                        class="ion-margin-top"
                                        @click="submitForm()"
                                        :disabled="files.length === 0"
                                        v-else
                                        >Hochladen</ion-button
                                    >
                                </div>
                                <div v-else-if="value.dokbox">
                                    Bitte logge dich ein, um deine persönlichen
                                    Anmerkungen, Bilder und Dateien zum heutigen
                                    Tag in deine DokBox hochzuladen.
                                </div>
                            </div>
                            <!-- <ion-card>asda as dasd asd</ion-card> -->
                        </div>
                    </template>
                    <div
                        class="c-accordion"
                        :class="{ '-open': accordionState.feedback }"
                    >
                        <div
                            class="c-accordion__header"
                            @click="toggleAccordion('feedback')"
                        >
                            <div class="c-accordion__icon">
                                <span :class="'icon-approved'"></span>
                            </div>
                            <div class="c-accordion__headline">
                                Wir freuen uns über dein Feedback zu Tag
                                {{ day }}
                            </div>
                            <div class="c-accordion__arrow">
                                <ion-icon name="arrow-dropdown"></ion-icon>
                            </div>
                        </div>
                        <div class="c-accordion__body ion-margin-top">
                            <b>Anwendbarkeit im Alltag</b>
                            <star-rating
                                :show-rating="false"
                                class="c-rating u-m-bottom-large u-m-top-small"
                                :star-size="40"
                                :padding="15"
                                v-model="ratingAnwendbarkeit"
                                :read-only="ratingAnwendbarkeit !== 0"
                            ></star-rating>
                            <b>Qualität des Inhalts</b>
                            <star-rating
                                :show-rating="false"
                                class="c-rating u-m-bottom-large u-m-top-small"
                                :star-size="40"
                                :padding="15"
                                v-model="ratingQualitaet"
                                :read-only="ratingQualitaet !== 0"
                            ></star-rating>
                            <b>Dein Wohlbefinden</b>
                            <star-rating
                                :show-rating="false"
                                class="c-rating u-m-bottom-large u-m-top-small"
                                :star-size="40"
                                :padding="15"
                                v-model="ratingAllgemeinbefinden"
                                :read-only="ratingAllgemeinbefinden !== 0"
                            ></star-rating>
                            <base-input
                                type="email"
                                v-model="email"
                                label="Deine E-Mail Adresse"
                                id="email"
                            ></base-input>
                            <base-textarea
                                id="nachricht"
                                v-model="nachricht"
                                label="Möchtest du uns noch was sagen?"
                                class="ion-margin-bottom"
                            ></base-textarea>
                            <ion-button expand="block" @click="sendMessage"
                                >Senden</ion-button
                            >
                        </div>
                        <!-- <ion-card>asda as dasd asd</ion-card> -->
                    </div>
                    <!-- <pre>
            {{ my21Content }}
            </pre> -->
                </ion-col>
            </ion-row>
        </template>
    </page>
</template>

<script>
import Page from "@/components/Page";
// import { getMy21Content } from "@/api/my21";
import StarRating from "vue-star-rating";
import BaseTextarea from "@/components/BaseTextarea";
import FilesUpload from "@/components/FilesUpload";
import { BASEURL } from "@/utils/globals";
import { Plugins } from "@capacitor/core";
import { dokbox } from "@/mixins/dokbox";
import { isLoggedIn } from "../api/auth";
import { handleError } from "../utils/error";
import { emailMy21Feedback, emailMy21Fragebogen } from "../api/my21";
import BaseInput from "@/components/BaseInput";
import BaseCheckbox from "@/components/BaseCheckbox";

const { Storage } = Plugins;

export default {
    mixins: [dokbox],
    components: {
        Page,
        StarRating,
        BaseTextarea,
        FilesUpload,
        BaseInput,
        BaseCheckbox,
    },
    props: {
        day: { type: String, required: true },
    },
    data() {
        return {
            baseurl: BASEURL,
            Browser: Plugins.Browser,
            my21Content: {},
            accordionState: {},
            email: "",
            nachricht: "",
            ratingAnwendbarkeit: 0,
            ratingQualitaet: 0,
            ratingAllgemeinbefinden: 0,
            existingDokboxDescription: "",
            resetFilesUpload: false,

            // fragebogen
            isFragebogenPossible: false,
            ziel: "",
            zielLabel: "Wo möchtest du nach dem 21-Tage-Programm stehen?",
            augenmerk: "",
            augenmerkLabel:
                "Worauf möchtest du die nächsten drei Wochen besonderen Augenmerk legen?",
            teilnahmebedingungen: false,
        };
    },
    watch: {
        ratingAnwendbarkeit(value) {
            this.trackEvent("Anwendbarkeit", value);
            Storage.set({
                key: "my21-day" + this.day + "-anwendbarkeit",
                value: value,
            });
        },
        ratingQualitaet(value) {
            this.trackEvent("Qualität", value);
            Storage.set({
                key: "my21-day" + this.day + "-qualitaet",
                value: value,
            });
        },
        ratingAllgemeinbefinden(value) {
            this.trackEvent("Allgemeinbefinden", value);
            Storage.set({
                key: "my21-day" + this.day + "-allgemeinbefinden",
                value: value,
            });
        },
        reset(value) {
            if (value) {
                this.getDokboxFiles();
                this.$store.commit("dokbox/setReset", false);
                this.resetFilesUpload = true;
                this.$nextTick(() => {
                    this.resetFilesUpload = false;
                });
            }
        },
    },
    mounted() {
        const date = new Date();
        this.setMy21Content();
        this.$store.dispatch("my21/getMy21Content").then(() => {
            this.setMy21Content();
        });

        Storage.get({
            key: "my21-day" + this.day + "-anwendbarkeit",
        }).then(({ value: value }) => {
            if (value !== null) {
                this.ratingAnwendbarkeit = parseInt(value);
            }
        });
        Storage.get({
            key: "my21-day" + this.day + "-qualitaet",
        }).then(({ value: value }) => {
            if (value !== null) {
                this.ratingQualitaet = parseInt(value);
            }
        });
        Storage.get({
            key: "my21-day" + this.day + "-allgemeinbefinden",
        }).then(({ value: value }) => {
            if (value !== null) {
                this.ratingAllgemeinbefinden = parseInt(value);
            }
        });

        Storage.set({
            key: "my21-day" + this.day + "-done",
            value: "true",
        });

        // fragebogen
        Storage.get({
            key: "my21-fb-possible",
        }).then(({ value: value }) => {
            if (
                value !== "false" &&
                // date.getMonth() === 11 &&
                date.getFullYear() === 2020
            ) {
                this.isFragebogenPossible = true;
            }
        });

        isLoggedIn()
            .then(() => {
                this.formData = {
                    date: date.toISOString(),
                    name: "Gemeinsam gesund - Tag " + this.day,
                    categoryId: 4,
                    desc: "",
                    ispublic: false,
                    beraterinfo: false,
                    beratertext: "",
                    is360: false,
                };
                this.getDokboxFiles();
                this.email = this.$store.state.user.details.email;
            })
            .catch((error) => {
                handleError(error);
            });
    },
    computed: {
        reset() {
            return this.$store.state.dokbox.reset;
        },
    },
    methods: {
        sendMessage() {
            this.$store.commit("setLoading", true);
            const nachricht =
                this.nachricht +
                "<br /><br /><b>Bewertung</b><br />" +
                "Anwendbarkeit: " +
                this.ratingAnwendbarkeit +
                " Sterne<br />" +
                "Qualität: " +
                this.ratingQualitaet +
                " Sterne<br />" +
                "Allgemeinbefinden: " +
                this.ratingAllgemeinbefinden +
                " Sterne";
            emailMy21Feedback(this.email, nachricht).then((response) => {
                if (response.data.Status === 200) {
                    this.nachricht = "";
                    this.$ionic.alertController
                        .create({
                            header: "Erfolgreich abgesendet",
                            buttons: [
                                {
                                    text: "Ok",
                                    role: "cancel",
                                },
                            ],
                        })
                        .then((a) => {
                            a.present();
                        });
                }
            });
        },
        showFragebogenBedingungen() {
            this.$ionic.alertController
                .create({
                    header: "Teilnahmebedingungen",
                    message:
                        "Veranstalter des Gewinnspiels ist die Bausparkasse Wüstenrot AG, Alpenstraße 70, 5020 Salzburg. Durch die Teilnahme am Gewinnspiel stimmt der/die TeilnehmerIn den nachstehenden Teilnahmebedingungen zu und bestätigt, diese gelesen und verstanden zu haben. Die GewinnerInnen erhalten jeweils 1 von 5 exklusiven Dr. Lalouschek Buch Paketen. Voraussetzung für die Teilnahme am Gewinnspiel ist die vollständige Beantwortung der beiden Fragen zu Tag 1 des MY21 Programms über die Klickmal App oder klickmal.at. Zeitraum des Gewinnspiels: alle von 27.11.2020 bis 31.12.2020 eingegangen Antworten nehmen am Gewinnspiel teil. Über den/die GewinnerIn entscheidet das Losverfahren. Der Rechtsweg ist ausgeschlossen. Über das Gewinnspiel wird kein Schriftverkehr geführt. Eine Barablöse ist nicht möglich. Die GewinnerInnen werden schriftlich verständigt. Der/Die GewinnerIn muss innerhalb von 14 Tagen ab Verständigung antworten. Sollte innerhalb der 14 Tagen keine Rückmeldung erfolgen, behält sich die Bausparkasse Wüstenrot AG das Recht vor, eine/n neue/n GewinnerIn zu ermitteln. Teilnahmeberechtigt sind Personen ab dem vollendeten 18. Lebensjahr, die in Österreich ihren ordentlichen Wohnsitz haben (ausgenommen sind Mitarbeiter der Wüstenrot Gruppe [BWAG, WVAG, WDS] und deren Angehörige). Irrtum, Änderungen und Druckfehler vorbehalten. Alle Angaben ohne Gewähr.",
                    buttons: [
                        {
                            text: "Verstanden",
                            role: "cancel",
                        },
                    ],
                })
                .then((a) => {
                    a.present();
                });
        },
        showFragebogenDatenschutz() {
            this.$ionic.alertController
                .create({
                    header: "Informationen zum Datenschutz",
                    // message: safestring,
                    message:
                        "Zum Zweck der Abwicklung des Gewinnspiels wird deine E-Mail Adresse verarbeitet und nach Durchführung des Gewinnspiels wieder gelöscht. Weitere Informationen zum Datenschutz, insbesondere zu den Betroffenenrechten, findest du in unserer Datenschutzerklärung, die unter <a href='https://www.wuestenrot.at/datenschutz'>www.wuestenrot.at/datenschutz</a> abrufbar ist.",
                    buttons: [
                        {
                            text: "Verstanden",
                            role: "cancel",
                        },
                    ],
                })
                .then((a) => {
                    a.present();
                });
        },
        sendFragebogen() {
            this.$store.commit("setLoading", true);
            const nachricht =
                this.zielLabel +
                "<br />" +
                this.ziel +
                "<br /><br />" +
                this.augenmerkLabel +
                "<br />" +
                this.augenmerk;
            emailMy21Fragebogen(this.email, nachricht).then((response) => {
                if (response.data.Status === 200) {
                    Storage.set({
                        key: "my21-fb-possible",
                        value: "false",
                    });
                    this.isFragebogenPossible = false;
                    this.$ionic.alertController
                        .create({
                            header: "Erfolgreich abgesendet",
                            message:
                                "Vielen Dank für deine Teilnahme am Gewinnspiel. Die Gewinner werden Anfang nächsten Jahres per E-Mail benachrichtigt.",
                            buttons: [
                                {
                                    text: "Ok",
                                    role: "cancel",
                                },
                            ],
                        })
                        .then((a) => {
                            a.present();
                        });
                }
            });
        },
        setMy21Content() {
            if (this.$store.state.my21.all[this.day]) {
                this.my21Content = { ...this.$store.state.my21.all[this.day] };
                for (let key in this.my21Content.content) {
                    this.$set(this.accordionState, key, false);
                    const replacedText = this.my21Content.content[
                        key
                    ].text.replace("###baseurl###", this.baseurl);
                    this.my21Content.content[key].text = replacedText;
                }
                this.$set(this.accordionState, "feedback", false);
            }
        },
        toggleAccordion(key) {
            // this.accordionState[key] = !this.accordionState[key];
            this.$set(this.accordionState, key, !this.accordionState[key]);
        },
        trackEvent(label, value) {
            this.$gtm.trackEvent({
                // event: null, // Event type [default = 'interaction'] (Optional)
                category: "Gemeinsam gesund Bewertung",
                action: value + " Sterne",
                label: "Tag " + this.day + " - " + label,
                value: parseInt(value),
                // noninteraction: false // Optional
            });
        },
        getDokboxFiles() {
            this.$store
                .dispatch("dokbox/getDokboxFiles", {
                    limitStart: 0,
                    limit: 50,
                    // limitYears: this.limitYears,
                    limitCategories: [4],
                    // ansicht: this.ansicht,
                })
                .then(() => {
                    const dokboxFiles = this.$store.state.dokbox.files;
                    let description = "";
                    for (let file of dokboxFiles) {
                        if (
                            file.fileCategoryId === 4 &&
                            file.fileName ===
                                "Gemeinsam gesund - Tag " + this.day
                        ) {
                            let existingFile = {
                                id: file.fileId,
                                url: file.fileThumbnailUrl,
                                fileType: file.fileType,
                                fileHash: file.fileHash,
                                downloadUrl: file.fileDownloadUrl,
                            };
                            description = file.fileDesciption;
                            this.existingFiles.push(existingFile);
                        }
                    }
                    this.$set(this.formData, "desc", description);
                    this.existingDokboxDescription = description;
                });
        },
    },
};
</script>

<style lang="scss">
.c-my21-card {
    background-color: red;
    overflow: initial;

    &__image {
        background: green;
        padding: var(--gangl-padding-small);
        margin-top: calc((var(--gangl-padding-small) + 20px) * -1);
        border-radius: 500px;
    }

    &__day {
        font-size: large;
        font-weight: bold;
    }

    &__title {
        font-size: large;
        text-transform: uppercase;

        @media only screen and (min-width: $breakpoint-sm) {
            font-size: x-large;
        }
    }

    &__titlebox {
        line-height: 2em;
    }

    &.-sport {
        background-color: #b2e2e1;
        img {
            background-color: #f5e7b8;
        }
    }
    &.-mental {
        background-color: #ecd078;
        img {
            background-color: #dfe3cc;
        }
    }
    &.-ernaehrung {
        background-color: #b3d99a;
        img {
            background-color: #f5e7b8;
        }
    }
    &.-gesundheit {
        background-color: #f2b8b8;
        img {
            background-color: #f5e7b8;
        }
    }
}

.c-accordion {
    margin: var(--gangl-padding-medium) 0;
    padding-top: var(--gangl-padding-medium);
    border-top: var(--ion-color-medium) 1px solid;
    &__header {
        display: flex;
        align-items: center;
        cursor: pointer;
    }
    &__headline {
        padding: 0 var(--gangl-padding-medium);
        font-size: large;
        font-weight: bold;
        display: inline-block;
        flex-grow: 1;
        word-break: break-word;
    }
    &__icon {
        display: inline-block;
        font-size: x-large;
    }
    &__arrow {
        display: inline-block;

        font-size: x-large;
    }
    &__body {
        display: none;
        padding: var(--gangl-padding-medium) 0;
    }
    &.-open {
        .c-accordion__body {
            display: block;
        }
        .c-accordion__arrow {
            transform: rotate(180deg);
        }
    }

    // ul {
    //     padding-left: 1.1em;
    // }

    // ol {
    //     padding-left: 1.2em;
    // }
    li {
        line-height: 1.5em;
        margin-bottom: 10px;
    }
    ol {
        list-style: none;
        counter-reset: item;
        // padding-left: 1.2em;
        padding-left: 1.3em;
        & > li {
            counter-increment: item;
            &:before {
                // margin-right: 10px;
                content: counter(item);
                margin-left: -1.3em;
                font-weight: bold;
                width: 1.3em;
                display: inline-block;
            }
        }
    }

    ul {
        list-style: none; /* Remove default bullets */
        padding-left: 1.7em;
        li::before {
            content: "\2022"; /* Add content: \2022 is the CSS Code/unicode for a bullet */
            color: #b2e2e1; /* Change the color */
            font-weight: bold; /* If you want it to be bold */
            display: inline-block; /* Needed to add space between the bullet and the text */
            width: 1em; /* Also needed for space (tweak if needed) */
            margin-left: -1em; /* Also needed for space (tweak if needed) */
            font-size: 1.5em;
            vertical-align: middle;
        }
    }
}

.c-rating {
    // margin: auto;
}
</style>
